export class FooterViewModel {
    facebook: string;
    instagram: string;
    twitter: string;
  }
